import { Briefcase, TrendingUp, Users, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";

const Careers = () => {
  return (
    <div className="w-full" data-testid="careers-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 via-purple-600 to-orange-500 text-white py-20 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Careers at Maruns Limited</h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Join our growing team as we expand across the UK
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            
            <p className="text-lg text-gray-700 leading-relaxed mb-12">
              Maruns Limited is a growing logistics and transport company providing services across London and the wider UK. As our operations expand, we are building a reliable and professional team to support increasing client demand.
            </p>

            {/* Current Opportunities */}
            <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-8 mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Current Opportunities</h2>
              
              <div className="space-y-8">
                <div className="bg-white p-6 rounded-lg shadow-sm">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">1. Logistics Manager</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Responsible for overseeing daily logistics operations, coordinating transport schedules, managing fleet resources, and ensuring timely and efficient service delivery across all sectors.
                  </p>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-sm">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">2. Operations Lead</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Leading on-the-ground operations including crew coordination, route planning, client communication, and quality assurance to maintain our high standards of service.
                  </p>
                </div>
              </div>
            </div>

            {/* Future Opportunities */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Future Opportunities</h2>
              <p className="text-lg text-gray-700 mb-6">
                We may also recruit for roles such as:
              </p>
              <ul className="space-y-3">
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mr-3"></span>
                  Delivery Drivers
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mr-3"></span>
                  Logistics Coordinators
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mr-3"></span>
                  Operations Assistants
                </li>
              </ul>
            </div>

            {/* Why Join Us */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Why Join Us</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-gray-50 p-6 rounded-lg text-center">
                  <TrendingUp className="w-10 h-10 text-blue-600 mx-auto mb-3" />
                  <p className="font-semibold text-gray-900 mb-2">Growing UK Logistics Company</p>
                  <p className="text-sm text-gray-600">Expanding operations and services</p>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg text-center">
                  <Briefcase className="w-10 h-10 text-orange-600 mx-auto mb-3" />
                  <p className="font-semibold text-gray-900 mb-2">Diverse Sectors</p>
                  <p className="text-sm text-gray-600">Work across various industries</p>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg text-center">
                  <Users className="w-10 h-10 text-green-600 mx-auto mb-3" />
                  <p className="font-semibold text-gray-900 mb-2">Professional Environment</p>
                  <p className="text-sm text-gray-600">Supportive team culture</p>
                </div>
              </div>
            </div>

            {/* Apply Section */}
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl p-8 text-center">
              <h2 className="text-3xl font-bold mb-4">Apply</h2>
              <p className="text-lg mb-6 text-white/90">
                To express interest in working with us, please contact:
              </p>
              <div className="space-y-3">
                <div className="flex items-center justify-center space-x-3">
                  <Mail className="w-5 h-5" />
                  <a href="mailto:marunsltd@outlook.com" className="text-white hover:text-blue-100 underline">
                    marunsltd@outlook.com
                  </a>
                </div>
                <div className="flex items-center justify-center space-x-3">
                  <Phone className="w-5 h-5" />
                  <a href="tel:+447405747177" className="text-white hover:text-blue-100 underline">
                    +44 7405 747177
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;
